






















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'PCheckboxGroup',
  props: {
    value: { default: () => [], type: Array as PropType<any[]> },
    items: { default: () => [], type: Array as PropType<Record<string, any>[]> },
    itemDisplay: { default: 'caption', type: String },
    itemDetail: { default: 'detail', type: String },
    itemValue: { default: 'id', type: String },
    itemDisabled: { default: 'disabled', type: String },
    label: { default: undefined, type: String },
    dense: { default: false, type: Boolean },
    spacious: { default: false, type: Boolean },
    horizontal: { default: false, type: Boolean },
  },
  data: () => ({
    innerValues: [] as boolean[],
  }),
  watch: {
    items: {
      immediate: true,
      handler() {
        this.refreshFromValue();
      },
    },
    value: {
      immediate: true,
      handler() {
        this.refreshFromValue();
      },
    },
    innerValues() {
      const values = this.innerValues
        .map((value, i) => (value ? this.items[i][this.itemValue] : undefined))
        .filter((value) => value !== undefined && value !== null);
      this.$emit('input', values);
    },
  },
  methods: {
    refreshFromValue() {
      if (this._.isArray(this.value)) {
        this.items.forEach((item, i) => {
          this.$withoutWatchers(() => {
            // This assumes that the value in items is unique
            this.$set(this.innerValues, i, this.value.includes(item[this.itemValue]));
          });
        });
      }
    },
  },
});
